const getWebviewUrl = (url: string): string => {
  if (!url) return '';

  return `sslocal://webview?url=${encodeURIComponent(url)}`;
};

const isHttpUrl = (url: string): boolean => {
  return url.startsWith('https://') || url.startsWith('http://');
};

export const handleUrl = (url: string, isInApp: boolean): string => {
  if (isInApp && isHttpUrl(url)) {
    return getWebviewUrl(url);
  }

  return url;
};
